import { LIST_VIEW_LIMIT } from "../constants";

export const handleToDateMove = (data, setToDate, startOfYear, setError, clearErrors) => {
    setToDate(data)
    const fromDate = startOfYear(new Date());
    const toDate = data
    if (toDate < fromDate) {
        setError('datePicker2', {
            type: "manual",
            message: "To date should be greater than from date"
        })
    }
    if (toDate > fromDate) {
        clearErrors(['datePicker2'])
    }
} 

export const getActivePageMove = (data, setActivePage, setPlatformResults, sortType, format, fromDate, toDate, selectedBlock, dispatch, getPlatformResultsAlt) => {
    setActivePage(data);
    const paginationPayLoad = {};
    paginationPayLoad['url'] = '/reports/platformanalytics/customerdata'
    paginationPayLoad['method'] = 'POST'
    paginationPayLoad['queryParam'] = { limit: LIST_VIEW_LIMIT, offSet: (((data * LIST_VIEW_LIMIT) - LIST_VIEW_LIMIT) < LIST_VIEW_LIMIT) ? 0 : (data * LIST_VIEW_LIMIT) - LIST_VIEW_LIMIT }
    paginationPayLoad['setMethod'] = setPlatformResults
    paginationPayLoad['sortType'] = sortType
    paginationPayLoad['toBeSent'] = {
        fromDate: format(fromDate, "LL/dd/yyyy"),
        toDate: format(toDate, "LL/dd/yyyy"),
        customerType: selectedBlock
    }
    dispatch(getPlatformResultsAlt(paginationPayLoad));
}